<template>
  <div>
    <div v-if="readed.length > 0">
      <h1 class="title">จำนวน {{ readed.length }} ตอนล่าสุด</h1>
      <div class="buttons">
        <a class="button is-primary" v-for="(link, index) in readed" :key="index" @click="$router.push(link)">
          {{ getNovelName(link.split('/')[2]) }} ตอนที่ {{ link.split('/')[4] }}
        </a>
      </div>
    </div>
    <div v-else>
      <h1 class="title has-text-centered">ท่านยังไม่เคยอ่านนิยายที่นี่มาก่อน</h1>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      readed: localStorage.getItem('my_read') ? localStorage.getItem('my_read').split(',').reverse() : []
    }
  },
  methods: {
    getNovelName (id) {
      var novel = this.$root.novels.find(novel => novel.id === id)
      if (novel) {
        return novel.name
      }
      return ''
    }
  }
}
</script>

<style lang="scss">

</style>
